import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    updateUrl: String,
    duration: Number
  }

  dragstart(event) {
    event.dataTransfer.setData("application/x-update-url", this.updateUrlValue)
    event.dataTransfer.setData("application/x-duration", this.durationValue)
    event.dataTransfer.effectAllowed = "move"
    this.element.classList.add("opacity-50")
  }

  dragend(event) {
    this.element.classList.remove("opacity-50")
  }
}
